import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import { STATUSES } from '@/const/status'

export default {
  namespaced: true,
  state: {
    teacherTeams: [],
    totalRows: 0,
    statuses: STATUSES,
    departments: [],
  },
  getters: {
    teacherTeams: state => state.teacherTeams,
    totalRows: state => state.totalRows,
    statuses: state => state.statuses,
    departments: state => state.departments,
  },
  mutations: {
    SET_TEACHER_TEAMS: (state, { total, records }) => {
      state.totalRows = total
      state.teacherTeams = records
    },
    SET_DEPARTMENTS: (state, data) => {
      state.departments = data
    },

  },
  actions: {
    async readTeacherTeams({ commit }, params) {
      try {
        const response = await axios.get('uni/teacherTeams', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { total, records } = data.data
          commit('SET_TEACHER_TEAMS', { total, records })
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    // eslint-disable-next-line no-unused-vars
    async createTeacherTeams({ commit }, params) {
      try {
        const response = await axios.post('uni/teacherTeams', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    // eslint-disable-next-line no-unused-vars
    async updateTeacherTeams({ commit }, params) {
      try {
        const response = await axios.put(`uni/teacherTeams/${params.id}`, params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    // eslint-disable-next-line no-unused-vars
    async deleteTeacherTeams({ commit }, id) {
      try {
        const response = await axios.delete(`uni/teacherTeams/${id}`)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async getDepartmentsByOrganizationId({ commit }) {
      try {
        const response = await axios.get('uni/departments/getByOrganizationId')
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_DEPARTMENTS', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
  },
}
